import styled from 'styled-components';

export const StyledPanel = styled.div`
display: flex;
flex-direction: row;
width: 100%;
border: 1px solid none;
border-radius: 5px;
background-color: white;
box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19);
`
export const ItemPanel = styled.span`
display: flex;
flex-direction: row;
text-align: start;
background-color: hsl(180, 31%, 95%);
margin: 2%;
width: 9%;
height: 45%;
padding: 2px 0;
border-radius: 5px;
` 
export const ItemText = styled.span`
color: white;
padding: 4%;
margin-right: 3%;
color:  hsl(180, 29%, 50%);
` 
export const ItemClose = styled.span`
display: flex;
flex-direction: row;
text-align: end;
padding: 4% 6%;
margin: 0;
background-color:  hsl(180, 29%, 50%);
border-radius: 0px 5px 5px;
color: white;
justify-content: flex-end;
align-content: flex-end;
align-items: flex-end;
cursor: pointer;
&:hover {
    background-color: hsl(180, 8%, 52%);
    color: white;
  }
` 
export const Clear = styled.a`
  border: none;
  position: relative;
  right: -220px;
  border-radius: 10px;
  margin: 2% 2% 2% 12%;
  color: hsl(180, 29%, 50%);
  font-weight: 700;
`;